import { useRouter } from 'next/router';
import { ArrowRight } from '@components/icons';
import { MobileContainer, MobileWrapper, MobileContent, MobileBackdrop } from './MobileModal.styles';

export default function MobileModal() {
  const router = useRouter();

  return (
    <>
      <MobileBackdrop />
      <MobileContainer>
        <MobileWrapper>
          <MobileContent>
            <button onClick={() => router.back()}>
              <span>
                <ArrowRight />
              </span>{' '}
              Back
            </button>
            <h2>Switch to desktop view to view your dashboard.</h2>
          </MobileContent>
        </MobileWrapper>
      </MobileContainer>
    </>
  );
}
